/** @jsx jsx */
import { jsx } from "theme-ui"
import { AspectRatio } from "@theme-ui/components"
import { Grid } from "@theme-ui/components"
import TwoColumnSection, {
  Block as ColumnBlock,
} from "@components/TwoColumnSection"
import VicGov from "@components/assets/svg/vicgov.svg"
import Instagram from "@components/assets/svg/instagramLarge.svg"
import RMIT from "@components/assets/svg/rmit.svg"
import Levis from "@components/assets/svg/levis.svg"
import BHP from "@components/assets/svg/bhp.svg"
import PWC from "@components/assets/svg/pwc.svg"
import CTAHeadingBlock from "@components/CTAHeadingBlock"
const PartnersSection = ({ img }) => (
  <TwoColumnSection
    col1={
      <ColumnBlock
        styles={{
          bg: "turquoise",
          color: "darkPurple",
        }}
      >
        <CTAHeadingBlock
          heading="Legendary partners"
          body="Our work wouldn’t be possible without the people who support us. If you’d like to join forces and work together, get in touch!"
          buttonLabel="Partner with Minus18"
          buttonLink="/partners"
        />
      </ColumnBlock>
    }
    col2={
      <ColumnBlock
        styles={{
          bg: "darkPurple",
        }}
      >
        <div
          sx={{
            height: "100%",
            width: "100%",
          }}
        >
          {img ? (
            <img src={img} width="100%" />
          ) : (
            <Grid
              columns={[2, null, 3]}
              sx={{
                height: "100%",
              }}
            >
              <AspectRatio
                ratio={16 / 9}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <VicGov />
              </AspectRatio>
              <AspectRatio
                ratio={16 / 9}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  color: "white",
                }}
              >
                <div
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <Instagram width="100%" />
                </div>
              </AspectRatio>
              <AspectRatio
                ratio={16 / 9}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <RMIT />
              </AspectRatio>
              <AspectRatio
                ratio={16 / 9}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Levis />
              </AspectRatio>
              <AspectRatio
                ratio={16 / 9}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <BHP />
              </AspectRatio>
              <AspectRatio
                ratio={16 / 9}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <PWC />
              </AspectRatio>
            </Grid>
          )}
        </div>
      </ColumnBlock>
    }
  />
)

export default PartnersSection
